import { render, staticRenderFns } from "./AnswerOptionImage.vue?vue&type=template&id=9681669c&scoped=true"
import script from "./AnswerOptionImage.vue?vue&type=script&lang=js"
export * from "./AnswerOptionImage.vue?vue&type=script&lang=js"
import style0 from "./AnswerOptionImage.vue?vue&type=style&index=0&id=9681669c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9681669c",
  null
  
)

export default component.exports